var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 16C27 22.0751 22.0751 27 16 27V29C23.1797 29 29 23.1797 29 16H27ZM16 27C9.92487 27 5 22.0751 5 16H3C3 23.1797 8.8203 29 16 29V27ZM5 16C5 9.92487 9.92487 5 16 5V3C8.8203 3 3 8.8203 3 16H5ZM16 5C22.0751 5 27 9.92487 27 16H29C29 8.8203 23.1797 3 16 3V5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3741 12.7071C15.7646 12.3166 15.7646 11.6834 15.3741 11.2929C14.9836 10.9024 14.3504 10.9024 13.9599 11.2929L15.3741 12.7071ZM10.667 16L9.95989 15.2929C9.56936 15.6834 9.56936 16.3166 9.95989 16.7071L10.667 16ZM13.9599 20.7071C14.3504 21.0976 14.9836 21.0976 15.3741 20.7071C15.7646 20.3166 15.7646 19.6834 15.3741 19.2929L13.9599 20.7071ZM21.3337 17C21.8859 17 22.3337 16.5523 22.3337 16C22.3337 15.4477 21.8859 15 21.3337 15V17ZM13.9599 11.2929L9.95989 15.2929L11.3741 16.7071L15.3741 12.7071L13.9599 11.2929ZM9.95989 16.7071L13.9599 20.7071L15.3741 19.2929L11.3741 15.2929L9.95989 16.7071ZM21.3337 15L10.667 15L10.667 17L21.3337 17V15Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.eff19c91fd534ad876aa6e5a3d8bfec4.svg";
export { ForwardRef as ReactComponent };